export default __webpack_public_path__ + "c6033fb2adc9ba5e3cf35c81d251060a.svg";